import { useMedia } from '@landsbankinn/ui-kit';

export const useScreenSize = () => {
  const isMobile = useMedia('sm', 'smaller or equal');
  const isXL = useMedia('xl');
  return { isMobile, isXL };
};
